import { jsx } from 'react/jsx-runtime';
import { usePDFContent } from './PDF.js';
import { TextToolbar } from '../../ExpandedResource/Content/Document/TextToolbar.js';

const PDFToolbar = () => {
  const { onAnnotationCreation, onHighlightCreation, contentRef } = usePDFContent();
  return /* @__PURE__ */ jsx(TextToolbar, {
    documentEl: contentRef.current,
    onAnnotationCreation,
    onHighlightCreation
  });
};

export { PDFToolbar as default };
//# sourceMappingURL=PDFToolbar.js.map
